export const ChevronLeftIcon = () => (
  <svg className="mc-icon-svg" xmlns="http://www.w3.org/2000/svg" width="10px" height="31px" viewBox="0 0 10 31">
    <path fill="#fff" d="M0,15.5L9.367,0.492L10,1.506L1.266,15.5L10,29.493l-0.633,1.014L0.632,16.514v0L0,15.5z" />
  </svg>
);
